import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";

interface Props {
    hasChanges: boolean;
    isSaving: boolean;
    onDiscard: () => void;
    onSave: () => Promise<void>;
}

export const ApplyReportTemplateFooter = ({
    hasChanges,
    isSaving,
    onDiscard,
    onSave,
}: Props) => (
    <CommandIsland
        sticky
        alignEnd
        className={commandIslandStyles.bulkActionsStickyFooter}
    >
        <Button
            variant="secondary"
            size="md"
            disabled={!hasChanges || isSaving}
            onClick={onDiscard}
        >
            Discard changes
        </Button>
        <ButtonWithLoader
            variant="primary"
            size="md"
            type="button"
            loading={isSaving}
            onClick={onSave}
            disabled={!hasChanges}
            hotKey="mod+enter"
            hotKeyOptions={{
                description: "Save changes",
                preventDefault: true,
            }}
            hotKeyDisplayPosition="inline"
        >
            Save
        </ButtonWithLoader>
    </CommandIsland>
);
